import { render, staticRenderFns } from "./SellersManagementForm.vue?vue&type=template&id=05fc9765"
import script from "./SellersManagementForm.vue?vue&type=script&lang=js"
export * from "./SellersManagementForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports